import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from "@angular/core";
import { Reminder, ReminderStatus, ReminderViewModel } from "./reminder.model";
import { MenuItem } from "primeng/api";
import { ReminderService } from "./reminders.service";
import { map, takeUntil, tap } from "rxjs/operators";
import { combineLatest, Observable, Subject } from "rxjs";
import { TieredMenu } from "primeng/tieredmenu";
import { PrimeNGHelpersService } from "../core/services/primeng-helpers.service";
import { TagService } from "../tags/tag.service";
import { LogService } from "../logs/log.service";
import { OverlayPanel } from "primeng/overlaypanel";

@Component({
	selector: 'reminder-card',
	templateUrl: './reminder-card.component.html',
	styleUrls: ['./reminder-card.component.css']
})
export class ReminderCardComponent implements AfterViewInit, OnDestroy {
	@ViewChild('menu') menu?: TieredMenu
	@ViewChild('attachmentPanel') attachmentPanel?: OverlayPanel
	@Input() reminder!: ReminderViewModel
	@Output('onUpdate') reminderUpdated = new EventEmitter<Reminder>()
	@Output('menuStatusChanged') menuOpen = new EventEmitter<boolean>()
	@Output() onDetailsClicked = new EventEmitter<Reminder>()

	constructor(
		private reminderService: ReminderService,
		private tagService: TagService
	) {}

	get isReadOnlyUser() {
		return (LogService.selectedLog?.role ?? 'READ') === 'READ'
	}
	
	tagStyleClass = ''
	private destroy$ = new Subject()
	
	get isSimple() {
		return this.reminder.startTime === this.reminder.endTime;
	}
	
	menuItems: MenuItem[] = [
		{
			label: 'Mark Reminder',
			items: []
		},
		{
			separator: true
		},
		{
			label: 'Details',
			command: () => this.onDetailsClicked.emit(this.reminder)
		}
	]
	
	ngAfterViewInit(): void {
		this.createLabelItems()
			.subscribe((items) => {
				if (this.menuItems[0])
					this.menuItems[0].items = items;
			});
		
		if (this.menu) {
			PrimeNGHelpersService.tieredMenuVisible(this.menu)
				.pipe(takeUntil(this.destroy$))
				.subscribe((val) => this.menuOpen.next(val));
		}

		if (this.attachmentPanel) {
			combineLatest([
				this.attachmentPanel.onShow
					.pipe(tap(() => this.menuOpen.next(true))),
				this.attachmentPanel.onHide
					.pipe(tap(() => this.menuOpen.next(false)))
			])
				.pipe(
					takeUntil(this.destroy$)
				)
				.subscribe();
		}
		
		setTimeout(() => this.tagStyleClass = this.tagService.getStylesForTagValues(this.reminder.tagValues).join(' '));
	}
	
	ngOnDestroy(): void {
		this.destroy$.next();
	}
	
	createLabelItems(): Observable<MenuItem[]> {
		
		const filter = (status: ReminderStatus) => {
			return status.name !== this.reminder.status.name &&
				status.name !== 'D' &&
				((this.isSimple)
					? (status.name !== 'E' && status.name !== 'A')
					: (status.name !== 'K'))
		}
		return this.reminderService.getStatuses()
			.pipe(map(statuses =>
				(statuses.filter(filter)
					.map(status => {
						return {
							label: status.description,
							command: () => this.reminderService.updateStatus(this.reminder, status)
								.subscribe(() => this.reminderUpdated.emit(this.reminder))
						}
					}) as MenuItem[])
			))
	}
}